import {createReducer, isAnyOf} from '@reduxjs/toolkit'
import {getEvents} from '../actions/events'

const defaultState: boolean = false

export const loading = createReducer(defaultState, builder => {
  builder
    .addCase(getEvents.pending, () => true)
    .addMatcher(isAnyOf(getEvents.fulfilled, getEvents.rejected), () => false)
})
